import { Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import MobileMenu from "../components/Layout/MobileMenu";
import { PATHS } from "../utils/paths";
import { getToken, getUserInfo } from "../utils/session";
import { decodeJwtPayload } from "../utils/jwt";

const ProtectedRouteShell = styled.div`
  min-height: 100vh;
`;

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  const location = useLocation();
  const userInfo = getUserInfo();
  const needsProfileSetup =
    token &&
    (userInfo.profileSetupPending === true ||
      decodeJwtPayload(token).username === null);

  if (needsProfileSetup && location.pathname !== PATHS.CompleteProfile) {
    return <Navigate to={PATHS.CompleteProfile} replace />;
  }

  if (token && location.pathname === PATHS.CompleteProfile) {
    return needsProfileSetup ? children : <Navigate to={PATHS.Learn} replace />;
  }

  const publicRoutes = [
    PATHS.Register,
    PATHS.Verification,
    PATHS.ForgotPassword,
    PATHS.NewPassword,
  ];

  const emailRequiredRoutes = [PATHS.Verification, PATHS.NewPassword];

  if (
    token &&
    (location.pathname === PATHS.Login ||
      publicRoutes.includes(location.pathname))
  ) {
    return <Navigate to="/" replace />;
  }

  if (
    !token &&
    !publicRoutes.includes(location.pathname) &&
    location.pathname !== PATHS.Login
  ) {
    return <Navigate to={PATHS.Login} replace />;
  }

  if (emailRequiredRoutes.includes(location.pathname) && !userInfo.email) {
    return <Navigate to={PATHS.Login} replace />;
  }

  const isPublicRoute =
    publicRoutes.includes(location.pathname) ||
    location.pathname === PATHS.Login;

  if (isPublicRoute) {
    return children;
  }

  return (
    <ProtectedRouteShell>
      <MobileMenu />
      {children}
    </ProtectedRouteShell>
  );
};

export default ProtectedRoute;
